import api from "@/services/api"
import { queryClient } from "@/queryClient"
import type {
  Category,
  CreateUpdateCategoryRequest,
} from "../sharedTypes/categories"
import { BASE_CATEGORIES_QUERY_KEY } from "../queryKeys"

export const createCategory = async (
  params: CreateUpdateCategoryRequest
): Promise<Category> => {
  const response = await api.post<Category>(
    "/products/categories/",
    {
      body: params,
    }
  )

  queryClient.invalidateQueries({
    queryKey: [BASE_CATEGORIES_QUERY_KEY],
  })

  return response.body
}
